export const rfIndexers = (state) => {
  return state.rfIndexers.data || []
}
export const rfIndexersLoading = (state) => {
  return state.rfIndexers.loading
}
export const rfIndexersLastUpdate = (state) => {
  return state.rfIndexers.lastUpdate
}

export const feeModels = (state) => {
  return state.feeModels.data || []
}
export const feeModelsLoading = (state) => {
  return state.feeModels.loading
}
export const feeModelsLastUpdate = (state) => {
  return state.feeModels.lastUpdate
}

export const portfolioModels = (state) => {
  return state.portfolioModels.data || []
}
export const portfolioModelsLoading = (state) => {
  return state.portfolioModels.loading
}
export const portfolioModelsLastUpdate = (state) => {
  return state.portfolioModels.lastUpdate
}
export const currencies = (state) => {
  return state.currencies.data || []
}
export const currenciesLoading = (state) => {
  return state.currencies.loading
}
export const currenciesLastUpdate = (state) => {
  return state.currencies.lastUpdate
}

